var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"page-layout"},[(_vm.hasTopSlot)?_c('div',{staticClass:"page-layout__top"},[_vm._t("top")],2):_vm._e(),(_vm.hasHeaderSlot)?_c('div',{staticClass:"page-layout__header"},[_vm._t("header")],2):_vm._e(),(_vm.hasMainSlot)?_c('div',{staticClass:"page-layout__main"},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }